import { challengeRejected, completedChallenge, corporateConfirmation, corporateRedo, questions } from './challenge-activity-timeline-entry';
import { advocateAccept, questions as questionsStage } from './stage';
export var activities = [{
  id: '1',
  currentStage: questionsStage,
  state: 'active',
  timeline: [questions, corporateRedo],
  pointsEarned: null,
  stageCompletions: null
}, {
  id: '2',
  currentStage: advocateAccept,
  state: 'pending_auto_result',
  timeline: [questions],
  pointsEarned: null,
  stageCompletions: null
}, {
  id: '3',
  currentStage: null,
  state: 'closed',
  timeline: [questions, completedChallenge],
  pointsEarned: 130,
  stageCompletions: null
}, {
  id: '4',
  currentStage: null,
  state: 'rejected',
  timeline: [questions, challengeRejected],
  pointsEarned: null,
  stageCompletions: null
}, {
  id: '5',
  currentStage: advocateAccept,
  state: 'active',
  timeline: [questions, corporateConfirmation],
  pointsEarned: null,
  stageCompletions: null
}];